module.exports = __webpack_public_path__ + "static/media/4.aa56f847.jpg";